import { styled } from "@acko-tech/building-blocks.ui.common";

export const InputFieldStyles = styled.div`
  width: 100%;
  height: 80px;
  ${(props) => props.wrapperStyles}
  @media (max-width: 768px) {
    ${(props) => props.mWrapperStyles}
  }
`;

export const Heading = styled.div`
  color: #040222;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;
